import { render, staticRenderFns } from "./financeWealthWayDailyList.vue?vue&type=template&id=8e71788a&lang=pug&"
import script from "./financeWealthWayDailyList.vue?vue&type=script&lang=ts&"
export * from "./financeWealthWayDailyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports